import { motion } from "framer-motion";
import { TerminalSquare } from "lucide-react";
import { ChatPanel } from "./ChatWidget";

const PLAYGROUND_SUGGESTIONS = [
  "Explain transformers in 2 sentences",
  "Write a haiku about stochastic calculus",
  "What is the Black-Scholes model?",
  "Explain Fama-MacBeth regression simply",
];

export const AiPlayground = () => {
  return (
    <section id="playground" className="relative py-24 lg:py-36" data-testid="ai-playground-section">
      <div className="pointer-events-none absolute left-1/3 top-0 h-[350px] w-[550px] rounded-full orb-violet" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <span className="font-mono text-xs uppercase tracking-[0.35em] text-cyan-400">
            {"// 07 — AI Lab"}
          </span>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-slate-50 sm:text-4xl lg:text-5xl">
            Ask me <span className="gradient-text">anything</span>
          </h2>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-slate-400 sm:text-base">
            A live GPT-5.4-mini model running inside this portfolio — answers stream in token by token.
            Technical, philosophical, or just for fun.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="mt-12 overflow-hidden rounded-2xl border border-white/10 bg-[#0A0B12]"
          data-testid="ai-playground-terminal"
        >
          <div className="flex items-center gap-2 border-b border-white/10 px-5 py-3">
            <span className="h-2.5 w-2.5 rounded-full bg-rose-500/70" />
            <span className="h-2.5 w-2.5 rounded-full bg-amber-500/70" />
            <span className="h-2.5 w-2.5 rounded-full bg-emerald-500/70" />
            <span className="ml-3 flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest text-slate-500">
              <TerminalSquare size={12} /> ai_lab — gpt-5.4-mini
            </span>
            <span className="ml-auto flex items-center gap-1.5 font-mono text-[9px] uppercase tracking-widest text-emerald-400">
              <span className="h-1.5 w-1.5 animate-pulse-dot rounded-full bg-emerald-400" /> streaming
            </span>
          </div>
          <div className="h-[440px]">
            <ChatPanel mode="playground" suggestions={PLAYGROUND_SUGGESTIONS} testidPrefix="lab" />
          </div>
        </motion.div>

        <p className="mt-4 font-mono text-[10px] text-slate-600">
          powered by OpenAI GPT-5.4-mini · conversations are stored to improve this demo
        </p>
      </div>
    </section>
  );
};
